module.exports = __webpack_public_path__ + "static/media/CommunityDetailsScreen_elAssistedLivingStudioUserPic_915103.319b170f.jpg";